import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 17:17:50
 * @LastEditTime: 2021-05-07 17:22:33
 * @LastEditors: wangshengqiang
 * @Description: 通用信息确认
 */

/* eslint-disable react-hooks/rules-of-hooks */
import cn from 'classnames';
import React from 'react';
import { useStore } from '@/store';
import ConfirmInfoTitle from '../ConfirmOrderInfo/ConfirmInfoTitle';
import { DetailItem } from '../ConfirmOrderInfo/transformValue';
import './index.less';

const getData = orderDetail => {
  const {
    paymentFrequency,
    insuranceStartDate,
    insuranceEndDate,
    pageExtraInfo = {}
  } = orderDetail || {};
  return _objectSpread({
    paymentFrequency,
    insuranceStartDate,
    insuranceEndDate
  }, pageExtraInfo === null || pageExtraInfo === void 0 ? void 0 : pageExtraInfo.common);
};

const commonConfirm = props => {
  const {
    attrs,
    label
  } = props;
  const {
    dataSource = [],
    isDefault
  } = attrs;

  if (!isDefault) {
    return null;
  }

  const orderDetail = useStore('orderDetail') || {
    insuredList: []
  };
  const data = getData(orderDetail);

  const _dataSource = dataSource.filter(item => item.isDefault === true);

  if (_dataSource.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    id: "infoConfirm",
    className: "c-InfoConfirm bg-fff"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(ConfirmInfoTitle, {
    title: label
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, _dataSource.map((item, index) => {
    const cls = cn({
      first: index === 0
    });
    return /*#__PURE__*/React.createElement(DetailItem, {
      className: cls,
      itemValue: data[item.value],
      dataSource: item.dataSource,
      itemlabel: item.label,
      itemKey: item.value,
      key: item.value
    });
  })));
};

export default commonConfirm;